import { SessionUser } from 'app/containers/auth/store/sessionSlice';
import { restApi } from 'services/restApi';

interface UserResponse {
  user: SessionUser;
  token: string;
  refresh_token: string;
}

interface LoginRequest {
  username: string;
  password: string;
}

export interface SetPasswordRequest {
  password: string;
  token: string;
}

interface SetPasswordResponse {
  success: boolean;
  error: string[];
}

interface ResetPasswordRequest {
  username: string;
}

interface ResetPasswordResponse {
  message: string;
}

interface RefreshRequest {
  refresh_token: string;
}

export const authApi = restApi.injectEndpoints({
  endpoints: builder => ({
    login: builder.mutation<UserResponse, LoginRequest>({
      query: credentials => ({
        url: '/token',
        method: 'POST',
        body: credentials,
      }),
    }),
    refresh: builder.mutation<UserResponse, RefreshRequest>({
      query: refreshRequest => ({
        url: '/token/refresh',
        method: 'POST',
        body: refreshRequest,
      }),
    }),
    setPassword: builder.mutation<SetPasswordResponse, SetPasswordRequest>({
      query: setPasswordRequest => ({
        url: '/users/set-password',
        method: 'POST',
        body: setPasswordRequest,
        headers: { Authorization: '' },
      }),
    }),
    resetPassword: builder.mutation<ResetPasswordResponse, ResetPasswordRequest>({
      query: resetPasswordRequest => ({
        url: '/users/reset-password',
        method: 'POST',
        body: resetPasswordRequest,
        headers: { Authorization: '' },
      }),
    }),
  }),
});

export const { useLoginMutation, useRefreshMutation, useSetPasswordMutation, useResetPasswordMutation } = authApi;
